import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { CustomFormData, FormFields } from '@orderform/widgets';
import { InputsGeneratorModule } from './inputs-generator.module';

/**
 * Standalone custom-element wrapper around InputsGeneratorComponent.
 *
 * Registered as `<ds-orderform-inputs-generator>` (see app.module.ts) so the Vue orderform can
 * embed the proven Angular address-field renderer inside its own dialogs — specifically the
 * Payment Express Checkout country/zip tax-calculation dialog. Vue sets `fields` / `data` as JS
 * properties and listens for the `dataChanges` / `stateChange` custom events (Angular Elements
 * maps @Input()->property and @Output()->CustomEvent).
 *
 * Being standalone and importing InputsGeneratorModule keeps the inner component's template
 * scope and DI intact when created outside its original module tree.
 */
@Component({
  standalone: true,
  selector: 'orderform-inputs-generator-element',
  imports: [InputsGeneratorModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <orderform-inputs-generator
      [fields]="fields"
      [data]="data"
      [excludeFromOrderValidation]="excludeFromOrderValidation"
      (dataChanges)="dataChanges.emit($event)"
      (stateChange)="stateChange.emit($event)"
    ></orderform-inputs-generator>
  `,
})
export class InputsGeneratorElementComponent {
  @Input() fields: FormFields.Field[] = [];
  @Input() data: CustomFormData = {};
  /** Keep these fields out of the global order form validation (dialog-scoped inputs). */
  @Input() excludeFromOrderValidation: boolean | string | null = true;

  @Output() readonly dataChanges = new EventEmitter<CustomFormData>();
  @Output() readonly stateChange = new EventEmitter<unknown>();
}
